import {FlatButton} from 'material-ui';
import {Link} from 'react-router-dom';
import React from 'react';
import styled from 'styled-components';
import {HeadlineH1} from './text/Headlines';
import {NewButton} from './form/FormElements';
import {
  ROLE_ADMIN,
  ROLE_EMPLOYEE,
  ROLE_SUPER_ADMIN,
  ROLE_USER,
  getTranslatedRole,
} from '../constants/userConstants';
import BigLoadingIndicator from './BigLoadingIndicator';
import EntityTable from './table/EntityTable';
import {FileCloudDone} from 'material-ui/svg-icons';
import {withNamespaces} from 'react-i18next';

export const isDev = () => {
  return !window.location.href.includes('hauserwirth.com');
};

let IconLock = require('../img/ic_lock.svg');

const Wrapper = styled.div`
  margin-bottom: 20px;
`;

const getTableConfig = (history, t) => ({
  maxRows: 30,
  filterString: entity => {
    return (
      entity.name +
      ' ' +
      entity.loginName +
      ' ' +
      t(`role.${getTranslatedRole(entity.role)}`)
    );
  },
  cols: [
    {
      header: t('user.name'),
      valueKey: 'name',
      method: name => name,
      width: '30%',
    },
    {
      header: t('user.loginName'),
      valueKey: 'loginName',
      method: loginName => loginName,
      width: '20%',
    },
    {
      header: t('user.role'),
      valueKey: 'role',
      method: role => t(`role.${getTranslatedRole(role)}`),
      width: '20%',
    },
    {
      header: t('user.disabled'),
      valueKey: 'active',
      method: active =>
        !active && <img src={IconLock} alt='Benutzer gesperrt' width={15} />,
      width: '10%',
    },
    {
      header: (
        <div style={{display: 'flex', alignItems: 'center'}}>
          {t('user.visible')} &zwnj;
          <FileCloudDone />
        </div>
      ),
      valueKey: '*',
      method: entry =>
        entry.role !== ROLE_USER ? null : (
          <FlatButton
            style={{paddingLeft: 10, paddingRight: 10}}
            primary={true}
            label={t('user.collections')}
            labelPosition='before'
            icon={entry.lastUnpublishedChangeTimestamp && <FileCloudDone />}
            onClick={e => {
              e.stopPropagation();
              history.push(`/art-collections/${entry._id}`);
            }}
          />
        ),
      width: '20%',
    },
  ],
});

function sort(
  {name, lastUnpublishedChangeTimestamp: last},
  {name: name2, lastUnpublishedChangeTimestamp: last2}
) {
  if (last > last2) return -1;
  if (last < last2) return 1;
  return name - name2;
}

const UserComponent = ({
  data: {loading, searchUsers, refetch},
  createCollectionFolders,
  history,
  user,
  t,
}) => {
  return (
    <Wrapper>
      <HeadlineH1> {t('user.user')} </HeadlineH1>
      {(user.role === ROLE_ADMIN || user.role === ROLE_SUPER_ADMIN) && (
        <div>
          <FlatButton
            onClick={() => {
              refetch({input: {role: ROLE_USER}});
              history.replace(`/users/${ROLE_USER}`);
            }}>
            {t('user.collector')}
          </FlatButton>
          <FlatButton
            onClick={() => {
              refetch({input: {role: ROLE_EMPLOYEE}});
              history.replace(`/users/${ROLE_EMPLOYEE}`);
            }}>
            {t('user.employe')}
          </FlatButton>
          <FlatButton
            onClick={() => {
              refetch({input: {role: ROLE_ADMIN}});
              history.replace(`/users/${ROLE_ADMIN}`);
            }}>
            {t('user.admins')}
          </FlatButton>
          {user.role === ROLE_SUPER_ADMIN && (
            <FlatButton
              onClick={() => {
                refetch({input: {role: ROLE_SUPER_ADMIN}});
                history.replace(`/users/${ROLE_SUPER_ADMIN}`);
              }}>
              {t('user.superAdmins')}
            </FlatButton>
          )}
          {isDev() && (
            <FlatButton
              onClick={async () => {
                try {
                  await createCollectionFolders();
                  alert('ordner erstellt');
                } catch (err) {
                  console.error('error on creating dirs');
                }
              }}>
              {t('user.testFolder')}
            </FlatButton>
          )}
        </div>
      )}{' '}
      <NewButton>
        <Link to='/new/user'>{t('user.newUser')}</Link>
      </NewButton>
      <EntityTable
        tableConfig={getTableConfig(history, t)}
        data={loading ? [] : [...searchUsers].sort(sort)}
        msg={t('user.noUserCreated')}
        onRowClicked={row => history.push('/logs/' + row._id)}
      />
      {loading && <BigLoadingIndicator />}
    </Wrapper>
  );
};
export default withNamespaces()(UserComponent);



// WEBPACK FOOTER //
// ./src/components/Users.js